import { connect } from 'react-redux';
import Sidebar from './sidebar';
import { getVisibleOrders } from '../../reselect/order.selector';

const mapStateToProps = state => ({
  orders: getVisibleOrders(state),
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
